import { createContext, useContext } from 'react';
import { CheckState } from 'src/types/types.ts';

export const CheckContext = createContext<CheckState | null>(null);

export function useCheck() {
  const v = useContext(CheckContext);
  if (!v) throw new Error('CheckContext missing');
  return v;
}
